import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fa-solid fa-chevron-left"
};
import { computed } from "vue";
import { ElButton } from "element-plus";
import NotificationEllipsis from "./NotificationEllipsis.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        level: { default: "primary" },
        size: { default: "medium" },
        shape: {},
        width: {},
        type: {},
        isPending: { type: Boolean, default: false },
        isDisabled: { type: Boolean, default: false },
        isActive: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const levelClass = computed(() => {
            return `button--${props.level}`;
        });
        const sizeClass = computed(() => {
            return `button--${props.size}`;
        });
        const typeClass = computed(() => {
            return props.type ? `button--${props.type}` : "";
        });
        const shapeClass = computed(() => {
            return props.shape ? `button--${props.shape}` : "";
        });
        const widthClass = computed(() => {
            return props.width ? `button--${props.width}` : "";
        });
        const _isDisabled = computed(() => {
            return props.isPending || props.isDisabled;
        });
        const activeClass = computed(() => {
            return props.isActive ? "button--active" : "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElButton), {
                class: _normalizeClass(["button", [
                        levelClass.value,
                        shapeClass.value,
                        sizeClass.value,
                        typeClass.value,
                        widthClass.value,
                        activeClass.value,
                    ]]),
                disabled: _isDisabled.value
            }, {
                default: _withCtx(() => [
                    (_ctx.level === 'back')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                        : _createCommentVNode("v-if", true),
                    _renderSlot(_ctx.$slots, "default"),
                    (_ctx.isPending)
                        ? (_openBlock(), _createBlock(NotificationEllipsis, { key: 1 }))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["class", "disabled"]));
        };
    }
});
